/** Mapbox defaults shared by the destination, POI and tour map components. */

/** Vietnam-wide fallback centre used when a map has no data to frame yet. */
export const VIETNAM_MAP_CENTER = { latitude: 16.047079, longitude: 108.20623 }

/** Camera options when fitting a map to its boundary/route bounds (instant jump, capped zoom). */
export const MAP_FIT_BOUNDS_OPTIONS = { padding: 60, duration: 0, maxZoom: 16 } as const

/** Mean Earth radius, used by the haversine distance helper. */
export const EARTH_RADIUS_KM = 6371

// Destination boundary editor
export const DESTINATION_MAP_DEFAULT_VIEW = { ...VIETNAM_MAP_CENTER, zoom: 6 }
export const DESTINATION_CENTER_POINT_ZOOM = 18
export const DESTINATION_VERTEX_COLOR = '#16A34A'
export const DESTINATION_MIDPOINT_COLOR = '#86EFAC'

// Tour route preview/editor
export const TOUR_MAP_DEFAULT_VIEW = { ...VIETNAM_MAP_CENTER, zoom: 16 }
export const TOUR_DESTINATION_CENTER_ZOOM = 14
export const TOUR_FIRST_POINT_ZOOM = 16
export const TOUR_ROUTE_LINE_COLOR = '#6366F1'
export const TOUR_VERTEX_COLOR = '#6366F1'
export const TOUR_MIDPOINT_COLOR = '#A5B4FC'

// POI location picker
export const POI_MAP_DEFAULT_ZOOM = 14
/** Wait after the last keystroke before geocoding the typed address. */
export const GEOCODE_SEARCH_DEBOUNCE_MS = 700
